module.exports = __webpack_public_path__ + "static/media/aktifitasOff.b1dc5c61.svg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Components/Nav-Home/aktifitasOff.svg
// module id = 64
// module chunks = 1